import { LOCALES } from '../locales';

export default {
	[LOCALES.TURKISH]: {
		'hello': 'Hello, {name}!',
        'TÜM TERMİNALLER':'TÜM TERMİNALLER',
        'BÖLÜM BAZINDA': 'BÖLÜM BAZINDA',
        'FİLTRE BAZINDA': 'FİLTRE BAZINDA',
        'Bildiren':'Bildiren',
        'Renk':'Renk',       
        'Sicil':'Sicil',
        'Parça':'Parça',
        'Hata':'Hata',
        'Saat':'Saat',
        'Hata Türü':'Hata Türü',
        'Hata Sor':'Hata Sor',
        'Alt Sorumlu':'Alt Sorumlu',
        'Kaydet':'Kaydet',
        'İşlem':'İşlem',
        'MONTAJ NO':'MONTAJ NO',
        'BODY NO':'BODY NO',
        'ARA':'ARA',
        'Teknik Destek':'Teknik Destek',
        'ARAÇ LİSTESİ':'ARAÇ LİSTESİ',
        'MANUEL HATA':'MANUEL HATA',
        'ÇOKLU HATA':'ÇOKLU HATA',
        'HATA LİSTESİ':'HATA LİSTESİ',
        'HATA KOPYA': 'HATA KOPYA',
        'ÇIKIŞ': 'ÇIKIŞ',
        'Toplam satır':'Toplam satır',
        'HATA GİRİŞ EKRANI':'HATA GİRİŞ EKRANI',
        'HIZLI KAYDET':'HIZLI KAYDET',
        'KAYDET VE GEÇ':'KAYDET VE GEÇ',
        'HATA KAYIT':'HATA KAYIT',
        'ARA':'ARA',
        'TERMİNAL İLK RESMİ':'TERMİNAL İLK RESMİ',
        'SIK GELEN HATA':'SIK GELEN HATA',
        'MANİFEST':'MANİFEST',
        'ÇIKIŞ':'ÇIKIŞ',
        'MODEL İLK RESMİ':'MODEL İLK RESMİ',
        'GERİ':'GERİ',
        'HATA LİSTESİ':'HATA LİSTESİ',
        'TEMİZLE':'TEMİZLE',
        'BÜYÜK FONT':'BÜYÜK FONT',
        'Harigami':'Harigami',
        'Tarih':'Tarih',
        'Terminal Listesi':'Terminal Listesi',
        'Sicil No':'Sicil No',
        'Şifre':'Şifre',
        'Giriş Yap':'Giriş Yap',
        'Kapat':'Kapat',
        'Montaj No':'Montaj No',
        'Vardiya':'Vardiya',
        'Girdiğiniz bilgiler hatalıdır!':'Girdiğiniz bilgiler hatalıdır!',
        'Giriş yapılıyor...':'Giriş yapılıyor...',
        'Açıklama':'Açıklama',
        'Alt Sorumlu':'Alt Sorumlu',
        'Yapılan İşlem':'Yapılan İşlem',
        'Çıkış Departmanı':'Çıkış Departmanı',
        'Hata Sınıfı':'Hata Sınıfı',
        'Sık Gelen Hata':'Sık Gelen Hata',
        'Hata Sorumlusu':'Hata Sorumlusu',
        'Kaydedildi':'Kaydedildi',
        'Örnek açıklama':'Örnek açıklama',
        'İptal':'İptal',
        'RENK':'RENK',
        'HATA GİRİŞİ':'HATA GİRİŞİ',
        'Başarılı bir şekilde hata kaydı güncellendi':'Başarılı bir şekilde hata kaydı güncellendi',
	}
}